import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { SymptomsCheckerConstants } from './../common/symptomCheckerConstants';

import 'rxjs/operator/map';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


@Injectable()
export class SymptomDetailsService {

    SymptomDetailsEndPoint = SymptomsCheckerConstants.EBSCO_Services.SymptomDetailsAPI;
    ArticleDetailsEndPoint = SymptomsCheckerConstants.EBSCO_Services.ArticleDetailsAPI;
    ContentSearchDetailsEndPoint = SymptomsCheckerConstants.EBSCO_Services.ContentSearchAPI;

    constructor(
        private http: Http
    ) { }

    getContentSearchDetails(id): Observable<any> {
        const apiURL = this.ContentSearchDetailsEndPoint + 'chunkid=' + id ;
        return this.http.get(apiURL)
        .map((response: Response) => response);

    }
    getSymptomDetails(id): Observable<any> {
        const apiURL = this.SymptomDetailsEndPoint + 'chunkid=' + id ;
        return this.http.get(apiURL)
        .map((response: Response) => response);

    }
    getArticleDetails(id): Observable<any> {
        const apiURL = this.ArticleDetailsEndPoint + '&chunkid=' + id ;
        return this.http.get(apiURL)
        .map((response: Response) => response);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/symptom-details-service.ts